/** Cloudflare published test site keys. They must not be accepted in production. */
const TEST_SITE_KEYS = new Set([
  "1x00000000000000000000AA",
  "2x00000000000000000000AB",
  "1x00000000000000000000BB",
  "2x00000000000000000000BB",
  "3x00000000000000000000FF",
]);

export function turnstileWidgetKey(): string {
  const key = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY?.trim() ?? "";
  if (!key) return "";
  if (process.env.NODE_ENV === "production" && TEST_SITE_KEYS.has(key)) return "";
  return key;
}
